import { useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from 'src/configContext';
import { Button } from 'src/modules/common/components/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { LocationState } from 'src/modules/LocationState';
import { PATHS } from 'src/types/Paths';

type Props = {
    label: string;
    isActuatorUnit: boolean;
    currentPage: number;
    locationState: LocationState;
    searchParams: URLSearchParams;
}

export const ValvesSelectValveButton = ({
    label,
    isActuatorUnit,
    currentPage,
    locationState,
    searchParams,
}: Props) => {
    const { gaPush } = useContext(ConfigContext);
    const onClick = useCallback(() => {
        gaPush({
            event: 'gaEvent',
            eventCategory: 'sizing tool',
            eventAction: 'step 3 - valve selection',
            eventLabel: 'select this valve',
        });
    }, [gaPush]);

    const actuatorsPage = locationState.valveLabel === label ? locationState.actuatorsPage : '1';

    return (
        <Button
            onClick={onClick}
            className="vss-valves-select-valve-button"
            as={Link}
            to={{
                pathname: [
                    ...(isActuatorUnit ? [
                        PATHS.Accessories,
                        encodeURIComponent(label),
                        encodeURIComponent(label),
                        '1',
                    ] : [
                        PATHS.Actuators,
                        encodeURIComponent(label),
                        actuatorsPage,
                    ]),
                ].join('/'),
                search: searchParams.toString(),
            }}
            state={
                locationState.valveLabel === label ? {
                    ...locationState,
                } : {
                    ...locationState,
                    valveLabel: label,
                    actuatorLabel: isActuatorUnit ? label : '',
                    checkoutComment: '',
                    valvesPage: currentPage.toString(),
                    actuatorsPage,
                    selectedAccessories: [],
                    combo: null,
                }
            }
            icon={(
                <div className="vss-valves-select-valve-button__icon">
                    <ArrowRightIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.selectDevice}/>
        </Button>
    );
};
